<div class="container" *ngIf="isLoaded">
    <mat-card *ngIf="dataSourcRepairs.data.length > 0" class="needs-improvement">
        <h2>Repair Queue</h2>

        <table class="inventory" mat-table [dataSource]="dataSourcRepairs" multiTemplateDataRows>
            <!-- Column Headers -->
            <ng-container matColumnDef="code">
                <td class="code-column" mat-cell *matCellDef="let item">
                    <div class="code"><span class="pound">#</span>{{item.number}}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <td mat-cell *matCellDef="let item">{{item.title}}</td>
            </ng-container>

            <ng-container matColumnDef="value">
                <td mat-cell *matCellDef="let item">
                    {{item.decision}}
                </td>
            </ng-container>

            <ng-container matColumnDef="dateListed">
                <td class="amount" mat-cell *matCellDef="let item">
                    {{item.lastModified | timeago}}
                </td>
            </ng-container>

            <tr class="inventory-row" apStatus="View item" mat-row (click)="viewItem(item.number)"
                *matRowDef="let item; let i = dataIndex; columns: columnsToDisplay1;">
            </tr>
        </table>

    </mat-card>
</div>